// ============================================================
// components/catalogo/FacturacionTab.jsx — Reglas de facturación por zona
// ============================================================

import React from 'react';

function FacturacionTab({ reglas, ciclos, zona, contextoIA, onEditRegla }) {
  const reglaActual = reglas.find(r => r.zone === zona);

  // Armar contexto facturación
  const billingContext = reglaActual
    ? [
        '[REGLAS_FACTURACION]',
        `Zona: ${reglaActual.zone}`,
        `Modalidad: ${reglaActual.mode}`,
        `Descripción IA: ${reglaActual.description}`,
        '',
        'Ciclos disponibles:',
        ...ciclos.map(c => `- ${c.name}: 1er vto ${c.first_due}, 2do vto ${c.second_due}, corte ${c.cutoff}`)
      ].join('\n')
    : 'Sin regla de facturación configurada para esta zona.';

  return (
    <div className="cat-billing-layout">
      {/* Panel izquierdo: reglas */}
      <div className="cat-panel">
        <div className="cat-panel-header">
          <div>
            <h2>Reglas de facturación por zona</h2>
            <p>La IA responde facturación desde esta configuración, no desde memoria del prompt.</p>
          </div>
        </div>

        {/* Cards por zona */}
        <div className="cat-billing-cards">
          {reglas.map(rule => (
            <div
              key={rule.id}
              className={`cat-billing-card ${rule.zone === zona ? 'active' : ''}`}
            >
              <div className="cat-billing-top">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                <b>{rule.zone}</b>
                {rule.active && <span className="cat-badge success">Activo</span>}
              </div>
              <h3>{rule.mode}</h3>
              <p>{rule.description}</p>
              <button
                className="cat-btn-secondary cat-btn-small"
                onClick={() => onEditRegla(rule)}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                Editar regla
              </button>
            </div>
          ))}
        </div>

        {/* Tabla ciclos */}
        <div className="cat-cycles-section">
          <h3>Ciclos comerciales</h3>
          <p className="cat-cycles-note">
            Compartidos con outbound. El ciclo del cliente se asigna operativamente en ISPCube, no por fecha de contratación.
          </p>
          <table className="cat-table">
            <thead>
              <tr>
                <th>Ciclo</th>
                <th>1er vencimiento</th>
                <th>2do vencimiento</th>
                <th>Corte</th>
              </tr>
            </thead>
            <tbody>
              {ciclos.map(c => (
                <tr key={c.id}>
                  <td><b>{c.name}</b></td>
                  <td>{c.first_due}</td>
                  <td>{c.second_due}</td>
                  <td>{c.cutoff}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Panel derecho: preview contexto IA */}
      <div className="cat-panel cat-preview-panel">
        <div className="cat-preview-hero">
          <div className="cat-icon-bubble">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="2"/><path d="M9 14l2 2 4-4"/></svg>
          </div>
          <div>
            <div className="cat-eyebrow">Contexto facturación</div>
            <h2>{reglaActual ? reglaActual.zone : zona}</h2>
            <p>{reglaActual ? reglaActual.mode : 'Sin configurar'}</p>
          </div>
        </div>

        <div className="cat-context-box">
          <div className="cat-context-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            Contexto que recibirá la IA
          </div>
          <pre>{billingContext}</pre>
        </div>

        {/* Contexto IA completo */}
        {contextoIA && (
          <details className="cat-context-details">
            <summary className="cat-context-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
              Contexto IA completo — {zona}
            </summary>
            <pre>{contextoIA}</pre>
          </details>
        )}
      </div>
    </div>
  );
}

export default FacturacionTab;
